import React from 'react'
import { Redirect, useHistory } from 'react-router-dom'
import routes from 'src/config/routes'
import { setPainDetails, usePainDetailsContext, usePainDetailsDispatch } from '@context/PainDetailsContext'
import usePainDetailsQuestions from '@hooks/usePainDetailsQuestions'
import { PainDetailsScreen } from '@screens/PainDetailsScreen/PainDetailsScreen'

export const PainDetails = () => {
  const history = useHistory()
  const painDetailsDispatch = usePainDetailsDispatch()
  const painDetailsQuestions = usePainDetailsQuestions()

  const { showPainTreatmentForm, painDetails } = usePainDetailsContext()

  const handleChange = (key: string, value: string | undefined) => {
    painDetailsDispatch(setPainDetails({ ...painDetails, [key]: value }))
  }

  if (!showPainTreatmentForm) {
    return <Redirect to={routes.treatment} />
  }

  return (
    <PainDetailsScreen
      answers={painDetails}
      questions={painDetailsQuestions}
      onChange={handleChange}
      onBackClick={() => history.push('/')}
      onContinue={() => history.push(routes.patient)}
    />
  )
}
